import React from 'react';
import ExpandMore from '@material-ui/icons/ExpandMore';

export default function ExpandMoreIcon() {

    return (
        <ExpandMore />
    );
}